import { render } from "./CarouselIndicators.vue?vue&type=template&id=5e2112c4&scoped=true"
import script from "./CarouselIndicators.vue?vue&type=script&lang=js"
export * from "./CarouselIndicators.vue?vue&type=script&lang=js"

import "./CarouselIndicators.vue?vue&type=style&index=0&id=5e2112c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2112c4"]])

export default __exports__